const globalWarning = {
  data: () => ({
    hideGlobalNotification: null,
    warningType: 'warning'
  }),

  computed: {
    globalWarningId () {
      return import.meta.env.VITE_MAINTENANCE_WARNING_ID
    },
    globalWarningText () {
      // if german language
      if (this.$getCurrentLocale() === 'de') {
        return import.meta.env.VITE_MAINTENANCE_WARNING_TEXT_DE
      }
      return import.meta.env.VITE_MAINTENANCE_WARNING_TEXT_EN
    }
  },

  methods: {
    setStorage ({ hide = true }) {
      localStorage.setItem(this.globalWarningId, hide)
      this.hideGlobalNotification = hide
    }
  },

  mounted () {
    const showNotification = import.meta.env.VITE_MAINTENANCE_WARNING === 'true'

    if (!showNotification || !localStorage) {
      this.hideGlobalNotification = true
      return
    }

    this.hideGlobalNotification = JSON.parse(localStorage.getItem(this.globalWarningId))
  }
}

export default globalWarning
